/**
 * User role constants and options
 */

export const USER_ROLES = {
	SUPER_ADMIN: 'super_admin',
	ADMIN: 'admin',
	MANAGER: 'manager',
	EMPLOYEE: 'employee',
};

/**
 * Role options for dropdowns/selects
 * Format: { value: role_key, label: display_name }
 */
export const ROLE_OPTIONS = [
	{ value: USER_ROLES.SUPER_ADMIN, label: 'Super Admin' },
	{ value: USER_ROLES.ADMIN, label: 'Admin' },
	{ value: USER_ROLES.MANAGER, label: 'Encargado' },
	{ value: USER_ROLES.EMPLOYEE, label: 'Empleado' },
];

